import { CatButton } from '@blocks-react/components/Button';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { useBreakpoint } from '../../../hooks';
import { priceCardTranslationProps, ServiceTranslationProps } from '../types';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { Conditional } from '../../common';
import styles from './ServiceRecommendationModelLoder.module.scss';

type ServiceRecommendationModelLoaderProps = {
  serviceTranslation: ServiceTranslationProps;
  priceCardTranslation: priceCardTranslationProps;
  isAddPartsEnabled: boolean;
};
export const ServiceRecommendationModelLoader = ({
  serviceTranslation,
  priceCardTranslation,
  isAddPartsEnabled
}: Readonly<ServiceRecommendationModelLoaderProps>) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);

  return (
    <>
      <div
        className={styles['sr-model-loader']}
        data-testid="service-recommendation-model-skeleton"
      >
        <Conditional
          test={!!isLG}
          fallback={
            <div>
              <div className="mb-2">
                <CatSkeleton
                  width="173px"
                  className={`${styles['sr-model-loader__text--mobile']}`}
                />
              </div>
              <div className="mb-3">
                <CatSkeleton className={styles['sr-model-loader__paragraph']} />
              </div>
              <div className="mb-2">
                <CatSkeleton
                  width="170px"
                  className={`${styles['sr-model-loader__text--mobile']}`}
                />
              </div>
              <div className="mb-3">
                <CatSkeleton className={styles['sr-model-loader__paragraph']} />
              </div>
              <div className="mt-2 mb-2 pt-1">
                <CatHeading level="h5">{priceCardTranslation.parts}</CatHeading>
              </div>
              <div className={`row g-3 p-3`}>
                <div className="col-4">
                  <CatSkeleton className={styles['sr-model-loader__img']} />
                </div>
                <div className="col-8">
                  <div className="mb-2">
                    <CatSkeleton
                      className={`${styles['sr-model-loader__text']}`}
                    />
                  </div>
                  <div>
                    <CatSkeleton
                      className={`${styles['sr-model-loader__img-right']}`}
                    />
                  </div>
                </div>
              </div>
              <div className={`row g-3 p-3`}>
                <div className="col-4">
                  <CatSkeleton className={styles['sr-model-loader__img']} />
                </div>
                <div className="col-8">
                  <div className="mb-2">
                    <CatSkeleton
                      className={`${styles['sr-model-loader__text']}`}
                    />
                  </div>
                  <div>
                    <CatSkeleton
                      className={`${styles['sr-model-loader__img-right']}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        >
          <>
            <div className={` ${styles['sr-model-loader__desktop']}`}>
              <div className={styles['sr-model-loader__desktop--left']}>
                <div className="mb-3">
                  <CatSkeleton
                    width="159px"
                    className={styles['sr-model-loader__text']}
                  />
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <CatSkeleton
                    width="115px"
                    className={styles['sr-model-loader__desktop__img']}
                  />

                  <div className="d-flex flex-column justify-content-between">
                    <CatSkeleton
                      width="207px"
                      className={
                        styles['sr-model-loader__desktop__img-con--header']
                      }
                    />
                    <CatSkeleton
                      className={
                        styles['sr-model-loader__desktop__img-con--footer']
                      }
                    />
                  </div>
                </div>
                <div className="mb-2">
                  <CatSkeleton
                    width="159px"
                    className={styles['sr-model-loader__text']}
                  />
                </div>

                <CatSkeleton
                  className={styles['sr-model-loader__text-bottom']}
                />
              </div>
              <div className={styles['sr-model-loader__desktop--right']}>
                <div className="mb-2">
                  <CatSkeleton
                    width="160px"
                    className={styles['sr-model-loader__text']}
                  />
                </div>
                <div className="mb-4">
                  <CatSkeleton
                    className={styles['sr-model-loader__img-right']}
                  />
                </div>
                <div className="mb-2">
                  <CatSkeleton
                    width="160px"
                    className={styles['sr-model-loader__text']}
                  />
                </div>
                <div className="mb-3">
                  <CatSkeleton
                    className={styles['sr-model-loader__desktop--paragraph']}
                  />
                </div>
              </div>
            </div>
            <Conditional test={isAddPartsEnabled}>
              <hr />
              <div>
                <CatHeading level="h5">{priceCardTranslation.parts}</CatHeading>
              </div>

              <div className="row g-4 mt-2" data-testid="parts-loader">
                {[...Array(4).keys()]?.map((row) => {
                  return (
                    <div className="col-3 px-4" key={row}>
                      <div className="mb-2">
                        <CatSkeleton
                          className={styles['sr-model-loader__img-card']}
                        />
                      </div>
                      <div className="mb-2">
                        <CatSkeleton
                          className={styles['sr-model-loader__text-bottom']}
                        />
                      </div>
                      <div>
                        <CatSkeleton
                          className={styles['sr-model-loader__img-footer']}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </Conditional>
          </>
        </Conditional>
      </div>
      <div
        slot="footer"
        data-testid="model-footer-container"
        className={styles['sr-model-loader__footer']}
      >
        {isAddPartsEnabled && (
          <CatButton
            fullWidth={!isLG}
            variant="primary"
            size="sm"
            data-testid="add-to-partcart"
            disabled
          >
            {serviceTranslation.addPartsToCart}
          </CatButton>
        )}
          <CatButton
            fullWidth={!isLG}
            size="sm"
            data-testid="request-service-btn"
            disabled
          >
            {serviceTranslation.requestServiceBtn}
          </CatButton>
      </div>
    </>
  );
};
